import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export interface UniversityProgram {
  id: string
  is_published: number
  name: string
  period: string
  passing_score: string
  image: string
  description: string
  price_non_rf: string
  price_rf: string
  study_form: string
  stream_id: string
  univer_id: string
  budget_places_number: string
  commerce_places_number: string
}

export interface UniversityDirectionRef {
  id: string
  name: string
  logo: string
  short_name?: string
  type?: number | string
}

export default class UniversityDirection extends BaseModel {
  static override constructorName = 'UniversityDirection'

  id: string = ''
  is_published: number = 0
  name: string = ''
  image: string = ''
  description: string = ''
  government_code: string = ''
  education_level: string = ''
  link: string = ''
  'budget_places_total': string = ''
  'commerce_places_total': string = ''
  created_at: string = ''
  updated_at: string = ''
  university_name: string = ''
  programs: UniversityProgram[] = []
  university: UniversityDirectionRef[] = []

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      const university = this.university[0]

      if (university) {
        this.university_name = university.short_name || university.name || ''
      }
    }
  }
}

registerModel(UniversityDirection)
